// import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';

export function heroBanner(settings) {
    var heroBanner = tns({
        container: settings.container,
        autoplay: true,
        autoplayButtonOutput: false,
        controls: false,
        onInit: fadeInSlider(settings.container),
        items: 1,
        nav: false,
        mouseDrag: true,
    });
}

export function imageSlider(settings) {
    var imageSlider = tns({
        autoplay: false,
        center: true,
        container: settings.container,
        controls: false,
        controlsContainer: '#image-slider--controls',
        gutter: 10,
        items: 1,
        // lazyload: true,
        loop: false,
        mouseDrag: true,
        nav: true,
        navContainer: '#image-slider--nav',
        responsive: {
            768: {
                controls: true
            }
        }
    })
}

export function customSlider(settings) {
    var customSlider = tns({...settings})
}


/**
 * Callback function to remove the opacity setting after slider has been initialised
 * 
 * @param {string} slider 
 */
 const fadeInSlider = (slider) => {
    const sliders = document.querySelectorAll(slider);
    sliders.forEach(slider => {
        slider.classList.remove('opacity-0');
    })
}